<template>
	<div class="positionRight" id="positionRight">
		<div class="top cursor">
			<span>在</span>
			<span>线</span>
			<span>咨</span>
			<span>询</span>
		</div>
		<div class="leftBox">
			<!-- <div>
				<img src="../../assets/telphone.png" width="20px" height="20px" alt="">
				<span>热线电话</span>
			</div>
			<p>176-5757-8075</p> -->
			<div>
				<!-- <img src="../../assets/lineicon.png" width="20px" height="20px" alt=""> -->
				<span>在线咨询</span>
			</div>
			<img src="https://app.sanmaoyk.com/static/serve/20251126-175505.jpg" style="width: 104px;height: 104px;border-radius: 4px;" />
			<p style="margin: 0;">微信扫一扫</p>
		</div>

		<!-- <div class="rightBox"> -->

		<div class="btm cursor" @click="scrollTop"></div>
		<!-- </div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isTop: false
			}
		},
		methods: {
			scrollTop() {
				var timer = setInterval(function() {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5);
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					this.isTop = true;
					if (osTop === 0) {
						clearInterval(timer);
					}
				}, 20)
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	// .positionRight{
	// display: flex;
	// justify-content: space-between;
	// align-items: flex-start;
	// width: auto;
	// position: fixed;
	// top: 300px;
	// right: 12px;

	.top {
		padding: 33px 27px;
		background: #AE60FC;
		border-radius: 4px;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 10px;
		z-index: 9999999;


		>img {
			margin-bottom: 8px;
		}

		>span {
			font-size: 16px;
			font-family: PingFang SC;
			color: #FFFFFF;
		}

		position: fixed;
		top: 300px;
		right: 12px;
	}



	.btm {
		width: 69px;
		height: 69px;
		background: #FFFFFF;
		border-radius: 4px;
		background-image: url(../../assets/top.png);
		background-repeat: no-repeat;
		background-position: center center;
		background-size: 29px 23px;
		position: fixed;
		top: 460px;
		right: 12px;
		z-index: 9999999;

	}

	.btm:hover {
		background-color: rgba(61, 125, 255, .2);
	}

	// .rightBox{
	//   a{
	//     display: block;
	//   }
	//   .top{
	//     width: 69px;
	//     padding: 12px 0 16px;
	//     background: #FFFFFF;
	//     border-radius: 4px;
	//     display: flex;
	//     flex-direction: column;
	//     align-items: center;
	//     margin-bottom: 10px;
	//     >img{ margin-bottom: 8px;}
	//     >span{font-size: 16px;font-family: PingFang SC;color: #999999; }
	//   }



	//   .btm{
	//     width: 69px;
	//     height: 69px;
	//     background: #FFFFFF;
	//     border-radius: 4px;
	//     background-image: url(../../assets/top.png);
	//     background-repeat: no-repeat;
	//     background-position: center center;
	//     background-size: 29px 23px;
	//   }
	// }

	.leftBox {
		// opacity: 0;
		width: 154px;
		background: #FFFFFF;
		box-shadow: 0px 5px 16px 0px rgba(206, 211, 212, 0.5);
		border-radius: 4px;
		display: none;
		flex-direction: column;
		align-items: center;
		margin-right: 10px;
		padding: 18px 0;
		position: fixed;
		top: 300px;
		right: 80px;
		z-index: 9999999;

		>div {
			display: flex;
			align-items: center;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #333333;
			margin-bottom: 10px;

			>img {
				margin-right: 8px;
			}
		}

		p {
			font-size: 14px;
			font-family: PingFang SC;
			color: #666666;
			margin-bottom: 40px;
		}
	}

	.positionRight .top:hover+.leftBox {
		display: flex;
	}

	// }
</style>



// WEBPACK FOOTER //
// src/components/positionRight/positionRight.vue